// const videoModalUrl = "https://www.youtube-nocookie.com/embed/9upYLm6WBpw";
const videoModalInsert = document.querySelector(".video-modal-trigger");
const videoModalStopPlay = document.querySelector("#videoModal .close");
const videoModalIframe = document.querySelector("#videoModal .iframe-wrapper");
// <iframe width="560" height="315" frameborder="0" allowfullscreen></iframe>

videoModalInsert.addEventListener("click", function() {
    videoModalIframe.innerHTML += "<iframe src='https://www.youtube-nocookie.com/embed/9upYLm6WBpw' width='560' height='315' frameborder='0' allowfullscreen></iframe>";
});

videoModalStopPlay.addEventListener("click", function() {
    videoModalIframe.innerHTML = "";
});
